import $$ from 'cmn-utils'
import { downloadExcel, formatAreaArray, getFileName } from "@/utils/tool";


const baseUrl = "/api/datav/datascreen/echarts/";
export default {
    exportExcel: (data) => {

        let baseUrl = baseUrl + "export-excel"; let paramsArray = [];
        //拼接参数
        Object.keys(data).map(key => {
            if (!data[key] || data[key] == 'null' || data[key] == 'undefined') delete data[key]
        })
        Object.keys(data).forEach(key => paramsArray.push(key + "=" + data[key]));
        if (baseUrl.search(/\?/) === -1) {
            baseUrl += "?" + paramsArray.join("&");
        } else {
            baseUrl += "&" + paramsArray.join("&");
        }
        fetch(baseUrl, {
            method: "GET",
            credentials: "include",
            headers: $$.getStore("headers")
        }).then(res => {
            res.blob().then(blob => {
                const fileName = getFileName(res.headers)
                downloadExcel(blob, fileName)
            });
        });
        return true
    },
    countWorkOrderDoubler: (params) => {
        return $$.get(baseUrl + 'count-work-order/doubler', params)
    },
    countWorkOrderStatePie: (params) => {
        return $$.get(baseUrl + 'count-work-order-state/pie', params)
    },

    countWorkOrderTypePie: (params) => {
        return $$.get(baseUrl + 'count-work-order-type/pie', params)
    },
    countWorkOrderHandleMethodPie: (params) => {
        return $$.get(baseUrl + 'count-work-order-handle-method/pie', params)
    },

    countAlarmDoubler: (params) => {
        return $$.get(baseUrl + 'count-alarm/doubler', params)
    },
    countAlarmStatePie: (params) => {
        return $$.get(baseUrl + 'count-alarm-state/pie', params)
    },

    // 工单增长趋势
    workOrderIncreasingTendencyLine: (params) => {
        return $$.get(baseUrl + 'work-order-increasing-tendency/line', params)
    },
    //告警增长趋势
    alarmIncreasingTendencyLine: (params) => {
        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        return $$.get(baseUrl + 'alarm-increasing-tendency/line', params)
    },

    //地图
    countDeviceMapMigrate: (params) => {
        return $$.get(baseUrl + 'count-device/map-migrate', params)
    },
    countDeviceStateDoubler: (params) => {
        return $$.get(baseUrl + 'count-device-state/doubler', params)
    },

    // 设备统计
    countDevicePie: (params) => {
        return $$.get(baseUrl + 'count-device/pie', params)
    },
    deviceIncreasingTendencyLine: (params) => {
        return $$.get(baseUrl + 'device-increasing-tendency/line', params)
    },


    newAlarmList: (params) => {
        return $$.get(baseUrl + 'new-alarm-list', params)
    },
    newWorkOrderList: (params) => {
        return $$.get(baseUrl + 'new-work-order-list', params)
    },
    countUnitCategoryPie: (params) => {
        return $$.get(baseUrl + 'count-unit-category/pie', params)
    },
    countUnitAlarmList: (params) => {
        return $$.get(baseUrl + 'count-unit-alarm-list', params)
    },
    countDeviceGroupbyAreaUnitProductBar: (params) => {
        return $$.get(baseUrl + 'count-device-groupby-area-unit-product/bar', params)
    },
    countDeviceMap: (params) => {
        return $$.get(baseUrl + 'count-device/map', params)
    },
    generalTotal: (params) => {
        return $$.get(baseUrl + 'general-total', params)
    },
}